import React from 'react';
import {Link} from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import MetaTags from "../components/MetaTags";

const Ukrasheniya: React.FC = () => {

    MetaTags(
        "Украшения из бисера",
        "Украшения из бисера - разделы сайта. Браслеты, колье, бусы, цветы, брелки и аксессуары из бисера. Украшение одежды бисером."
    )

    return <>
        <h2>Украшения из бисера</h2>
        <div className="row">
            <div className="col-sm-5 col-lg-4">
                <Link to="/braslet"><img src="/image/Braslet/mP1230111.jpg"
                                         className="xs-centered picture2 img-rounded" width="227" height="170"
                                         alt="Браслеты"/></Link>
            </div>
            <div className="col-sm-7 col-lg-8">
                <div className="description">
                    <p className="big">
                        <Link to="/braslet">Браслеты из бисера</Link></p>

                    <p>Их можно плести на леске или резинке, пришивать цветы или листики на широкую декоративную
                        резинку. Изготовить браслет можно на основе любой плоской цепочки.
                        Например, <Link to="/krestik">крестик</Link>, <Link to="/vosmerka">сетчатое плетение</Link> и т.д.</p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-5 col-lg-4">
                <Link to="/bousi"><img src="/image/Bousi/mmP1220106.jpg"
                                       className="xs-centered picture2 img-rounded" width="227" height="170"
                                       alt="Колье и бусы"/></Link>
            </div>
            <div className="col-sm-7 col-lg-8">
                <div className="description">
                    <p className="big">
                        <Link to="/bousi">Колье и бусы из бисера</Link></p>

                    <p>Здесь собраны украшения в разных техниках. Из цветочков, <Link to="/shnur">ажурного и плотного шнура</Link>, в
                        технике полотно, из нескольких бисерных нитей и другие.</p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-5 col-lg-4">
                <Link to="/otdelka"><img src="/image/Otdelka/mP3120120.jpg"
                                         className="xs-centered picture2 img-rounded" width="227" height="170"
                                         alt="Украшение одежды бисером"/></Link>
            </div>
            <div className="col-sm-7 col-lg-8">
                <div className="description">
                    <p className="big">
                        <Link to="/otdelka">Украшение одежды бисером</Link></p>
                    <p>Листики, цветы, снежинки, бабочки, дельфинчики и другие фигурки из бисера помогут украсить
                        одежду, сделать ее оригинальной и неповторимой.</p>

                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-5 col-lg-4">
                <Link to="/breloki-aksessuary"><img src="/image/Raznoe/mP9220010.jpg"
                                        className="xs-centered picture2 img-rounded" width="227" height="170"
                                        alt="Брелоки и аксессуары из бисер"/></Link>
            </div>
            <div className="col-sm-7 col-lg-8">
                <div className="description">
                    <p className="big">
                        <Link to="/breloki-aksessuary">Брелоки и аксессуары из бисера</Link></p>
                    <p>Например, <Link to="/podstavka">подставка под чашку</Link>. Для плетения брелков я использовала
                        в основном <Link to="/kvadrat-stolbik">квадратный столбик</Link>, а также <Link
                            to="/shnur">шнур</Link>, <Link to="/opletenie-bousin">оплетение бусин</Link> и т.д.</p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-5 col-lg-4">
                <Link to="/cvetochki"><img src="/image/Cvetochki/mP8020153.jpg"
                                           className="xs-centered picture2 img-rounded" width="227" height="170"
                                           alt="Цветы из бисера"/></Link>
            </div>
            <div className="col-sm-7 col-lg-8">
                <div className="description">
                    <p className="big">
                        <Link to="/cvetochki">Цветы из бисера</Link></p>

                    <p>Они могут быть плоскими и объемными. Можно изготавливать цветы как на проволоке, так и на леске.
                        Например, <Link to="/vetochka">веточка из бисера</Link> на проволоке.</p>
                </div>
            </div>
        </div>
    </>;
};

export default Ukrasheniya;

